"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _StackStyles = require("./Stack-styles");

var _ColumnsComponent = _interopRequireDefault(require("./Columns-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// iOS raise an error when we are using `direction`
// as props.
// so now for a workaround I used `dir`.
// https://stackoverflow.com/questions/60479653/invalid-ygdirection-row-should-be-one-of-inherit-ltr-rtl-react-native
function Stack({
  direction,
  ...props
}) {
  return /*#__PURE__*/_react.default.createElement(_StackStyles.StackContainer, _extends({
    dir: direction
  }, props), props.columns ? /*#__PURE__*/_react.default.createElement(_ColumnsComponent.default, {
    columns: props.columns,
    fillIfEmpty: props.fillIfEmpty
  }, props.children) : props.children);
}

var _default = Stack;
exports.default = _default;